import googleImg from "../../img/sliderGoogle.png";
import amazonLogo from "../../img/sliderAmazon.png";
import microsoft from "../../img/sliderMicrosoft.png";
import adobe from "../../img/sliderAdobe.png";
import razorpay from "../../img/sliderRazorpay.png";
import flipkart from "../../img/sliderFlipkart.png";
import walmart from "../../img/sliderWalmart.png";
import paytm from "../../img/sliderPaytm.png";
import oracle from "../../img/sliderOracle.png";
import paloalto from "../../img/sliderPaloalto.png";

const CompanyLogos = [
    {
        src: googleImg,
        text: "googleImg",
        classes: "springboot-google-logo",
    },
    {
        src: flipkart,
        text: "flipkart",
        classes: "springboot-flipkart-logo",
    },
    {
        src: adobe,
        text: "adobe",
        classes: "springboot-adobe-logo",
    },
    {
        src: microsoft,
        text: "microsoft",
        classes: "springboot-microsoft-logo",
    },
    {
        src: amazonLogo,
        text: "amazon",
        classes: "springboot-amazon-logo",
    },
    {
        src: walmart,
        text: "walmart",
        classes: "springboot-walmart-logo",
    },
    {
        src: razorpay,
        text: "razorpay",
        classes: "springboot-razorpay-logo",
    },
    {
        src: paytm,
        text: "paytm",
        classes: "springboot-paytm-logo",
    },
    {
        src: oracle,
        text: "oracle",
        classes: "springboot-oracle-logo",
    },
    {
        src: paloalto,
        text: "paloalto",
        classes: "springboot-paloalto-logo",
    },
];

export default CompanyLogos;
